import { useData } from "@/lib/data";
import { koliPairs, koliText } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function KoliTypeSelect({ value, onChange, testId, className = "" }) {
  const { koliTypes } = useData();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={`h-10 bg-[#FFFBF4] border-[#DCCFB8] ${className}`}>
        <SelectValue placeholder="Koli tipi seçin..." />
      </SelectTrigger>
      <SelectContent className="bg-[#EFE6D6] border-[#DCCFB8] text-[#2B2118]">
        {koliTypes.map((k) => (
          <SelectItem key={k.id} value={k.id} data-testid={`${testId}-option-${k.id}`}>
            {k.name} ({koliText(k.ratios)} = {koliPairs(k.ratios)} çift)
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
